module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/1/2-e37c221a1cb59bd92edc21f2aecb14c1.jpg";